import React, { Component } from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import SessionHelper from '../helpers/SessionHelper';
import PriceHelper from '../../shared/helpers/PriceHelper';
import './SessionPopover.css';
import { Availability } from './Availability';
import { BookButtons } from './BookButtons';
import { renderPricingBox } from '../../shared/components/PricingBox';

class SessionPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: [],
    };
  }

  onHide() {
    if (typeof this.props.onHide === 'function') {
      this.props.onHide();
    }
  }

  render() {
    const session = this.props.session;
    const subEvent = this.props.subEvent;
    const provider = session['imin:dataSource'].identifier;

    const startTimeString = DateTime.fromISO(subEvent.startDate).toLocaleString(
      DateTime.TIME_24_SIMPLE
    );
    let endTime = DateTime.fromISO(subEvent.endDate);
    if (endTime.second === 59) {
      endTime = endTime.plus({ seconds: 1 });
    }

    const endTimeString = endTime.toLocaleString(DateTime.TIME_24_SIMPLE);

    const aggregateOffer = session['imin:aggregateOffer'];
    const { offers } = PriceHelper.getPricesList(aggregateOffer, provider);

    const dateString = `${startTimeString} - ${endTimeString}`;

    return (
      <div className="SessionPopover">
        <div className="session-overlay" onClick={() => this.onHide()}></div>
        <div className="session-popover">
          <div className="closePopover" onClick={() => this.onHide()}>
            <FontAwesomeIcon icon="times" />
          </div>
          <div className="sessionName">{session.name}</div>
          <div className="sessionBody">
            <div className="sessionItem">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <span className="sessionTimes" style={{ flex: 1 }}>
                  {dateString}
                </span>
                {!this.props.shouldShowNoAvailability && (
                  <Availability
                    subEvent={this.props.subEvent}
                    shouldShowExactAvailability={this.props.shouldShowExactAvailability}
                    isSessionPopover
                  />
                )}
              </div>
              <span className="sessionDescription">
                {SessionHelper.description(session.description)}
              </span>
            </div>
            <div className="sessionItem">
              {!this.props.shouldShowNoAvailability && (
                <BookButtons
                  subEvent={this.props.subEvent}
                  eventSeries={this.props.eventSeries}
                  bookableProviders={this.props.bookableProviders}
                  uniqueId={this.props.session.identifier}
                  checkoutBaseUrl={this.props.checkoutUrl}
                  provider={provider}
                  isSessionPopover
                  memberDeepLinks={this.props.memberDeepLinks}
                />
              )}
              {renderPricingBox({ offers }, this.props.showPrices, true)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SessionPopover.propTypes = {
  onHide: PropTypes.func,
  session: PropTypes.object,
  subEvent: PropTypes.object,
  eventSeries: PropTypes.object,
  buttonStyle: PropTypes.object,
  checkoutUrl: PropTypes.string,
  checkoutTheme: PropTypes.string,
  shouldShowNoAvailability: PropTypes.bool,
  bookableProviders: PropTypes.array,
  shouldShowExactAvailability: PropTypes.bool,
  shouldNotShowDeepLinkButton: PropTypes.bool,
  memberDeepLinks: PropTypes.object,
  showPrices: PropTypes.bool,
};

export default SessionPopover;
